import { render, staticRenderFns } from "./OFileInput.vue?vue&type=template&id=83e9004c&scoped=true&"
import script from "./OFileInput.vue?vue&type=script&lang=js&"
export * from "./OFileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e9004c",
  null
  
)

export default component.exports